import React from 'react';
import { NavLink } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';

class Nav extends React.Component {

    state = {
        open: false
    };

    componentDidMount(){
        window.addEventListener("resize", this.closeNav);
    }

    closeNav = () => {
        if(this.state.open === true){
            if(window.innerWidth > 999){
                this.setState({
                    open: false
                })
            }
        }
    };

    /**
     * Open or close the mobile nav
     */
    toggleNav = () => {
        this.setState({
            open: !this.state.open
        })
    };

    render() {
        return (
            <div className="nav">
                <div className="container">
                    <NavLink to="/">
                        <img src={require('../../images/logo.svg')} alt="Partners Real Estate" />
                    </NavLink>
                    <div>
                        <div>
                            <NavLink to="/sign-up" className="btn">Create property alert</NavLink>
                            <NavLink to="/buy" className="btn">View all properties</NavLink>
                        </div>
                        <div>
                            <a href="tel:01624 777 044">01624 777 044</a>
                            <a href="mailto:hello@partners.co.im">hello@partners.co.im</a>
                        </div>
                        <div id="hamburger" onClick={this.toggleNav} className={this.state.open ? "close" : null}><span></span></div>
                    </div>
                </div>
                <nav className={this.state.open ? "visible" : null} onClick={this.toggleNav.bind(this)}>
                    <div className="container">
                        <NavLink to="/" exact={true}>Home</NavLink>
                        <NavLink to="/buy">Buy</NavLink>
                        <NavLink to="/let">Let</NavLink>
                        <NavLink to="/commercial">Commercial</NavLink>
                    </div>
                </nav>
            </div>
        );
    }
}

export default Nav;
